import React, { useState, useEffect, useCallback } from 'react'
import {
    CommunityLeadSaveUserDirectorApi, CommunityLeadGetUserDirectorByUserIdApi,
    CommunityLeadDeleteUserDirectorApi, getNameOnPanApi
} from './AddLeadActionCreator'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import InputField from '../../utils/InputMUI'
// import Routes from '../../../../Layout/Routes'
import { useLocation, useNavigate } from 'react-router-dom'
import DeletePopup from '../../utils/deletePopup'
import { WEBSITE } from '../../utils/commonFunction'

const EsignConfig = ({ data,handleTab , handlePage}) => {
    const [startingData, setStartingData] = useState({ userId: '', loanId: '', name: '', panNumber: '', aadharNumber: '', nameOnPan: '' })
    const [objectData, setObjectData] = useState([])
    const [loaderState, setLoaderState] = useState(false)
    const [, updateState] = useState();
    const forceUpdate = useCallback(() => updateState({}), []);
    const navigate = useNavigate();
    const location = useLocation();
    const [validationMsg, setValidationMsg] = useState({ status: true, msg: '', field: '' })
    const [deletePopupState, setDeletePopupState] = useState(false)
    const [idForDelete, setIdForDelete] = useState('')
    const [objectDataNew, setobjectDataNew] = useState({})

    useEffect(() => {
        // console.log('hello')
        if (data !== null && data.rowData !== undefined) {
            let changeStartingData = { ...startingData }
            changeStartingData.userId = data.rowData.userId
            if (data.rowData.loanId !== undefined) {
                changeStartingData.loanId = data.rowData.loanId
            }
            setStartingData(changeStartingData)
            objectData[0] = changeStartingData
            // objectData[1] = changeStartingData

            setObjectData(objectData)
            getDetail()
        }
    }, [])

    const getDetail = () => {
        CommunityLeadGetUserDirectorByUserIdApi(data.rowData.userId,
            callBack => {
                // console.log(callBack.data)
                if (callBack.data !== null && callBack.data.length > 0) {
                    callBack.data.forEach((element, i) => {
                        objectData[i] = element
                    })
                    // console.log(objectData)
                    setObjectData(objectData)
                    forceUpdate()
                }
            }, error => {

            })
    }


    const inputChange = (e, type, mainKey) => {
        // console.log(type)
        let newData = Object.assign({}, objectDataNew)
        newData[type + mainKey] = e
        setobjectDataNew(newData)

        let changeObjectData = { ...objectData[mainKey] }
        changeObjectData[type] = e
        // console.log(objectData[mainKey])
        if (type === 'aadharNumber') {
            if (e.length > 12) {
                changeObjectData.aadharNumber = e.slice(0, 12)
            }
        }
        if (type === 'panNumber' && changeObjectData['panNumber'].length === 10) {
            let data = {
                id: objectData[mainKey].userId,
                panNumber: changeObjectData['panNumber']

            }
            setLoaderState(true)
            getNameOnPanApi(data, callBack => {
                if (callBack.message === 'success') {
                    // let changeObjectData = Object.assign({}, objectData)
                    // changeObjectData[type] = e
                    // console.log(callBack.data.result)
                    // console.log(changeObjectData)
                    if (callBack && callBack.data && callBack.data['status-code'] === '101') {
                        changeObjectData['nameOnPan'] = callBack.data.result.name
                        setLoaderState(false)
                        // console.log(changeObjectData)

                    } else {
                        changeObjectData['nameOnPan'] = ''
                        changeObjectData['panNumber'] = ''
                        setLoaderState(false)
                        // console.log(changeObjectData)

                    }


                }
            }, error => {

            })
        }
        objectData[mainKey] = changeObjectData
        setObjectData(objectData)
        setValidationMsg({})
    }

    const mainActionHandler = (type, mainKey) => {
        if (type === 'mainAdd') {
            objectData[mainKey + 1] = startingData
            setObjectData(objectData)
            forceUpdate()
        } else if (type === 'mainRemove') {
            if (objectData.length > 1 && objectData[mainKey] !== undefined) {
                if (objectData[mainKey].id !== undefined && objectData[mainKey].id !== null && objectData[mainKey].id !== '') {
                    setIdForDelete(objectData[mainKey].id)
                    // setDeletePopupState(true)
                    CommunityLeadDeleteUserDirectorApi(objectData[mainKey].id,
                        callBack => {
                            // console.log(callBack)
                            if (callBack.message === 'success') {
                                objectData.splice(mainKey, 1)
                                setObjectData(objectData)
                                forceUpdate()
                            }
                        }, error => {

                        })
                } else {
                    objectData.splice(mainKey, 1)
                    setObjectData(objectData)
                    forceUpdate()
                }
            }
        }
    }

    const deleteHandler = (e) => {
        if (e === 'yes') {
            CommunityLeadDeleteUserDirectorApi(idForDelete,
                callBack => {

                }, error => {

                })
        }
        setDeletePopupState(false)
    }

    const validationHandler = (data) => {
        var SPACECHECK = /^[a-zA-Z][\sa-zA-Z]*/

        let formStatus = true
        var panFormat = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

        // for (let i = 0; i < data.length; i++) {
        //     if (data[i].name === '' || data[i].name === null) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter Name', field: 'name' + i })
        //         break
        //     }
        //     if (!SPACECHECK.test(data[i].name)) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'enter valid name', field: 'name' + i })
        //         break
        //     }
        //     if (data[i].panNumber === '' || data[i].panNumber === null) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter PAN Number', field: 'panNumber' + i })
        //         break
        //     } else if (!panFormat.test(data[i].panNumber)) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter Valid PAN Number', field: 'panNumber' + i })
        //         break
        //     }
        //     if (data[i].aadharNumber === '' || data[i].aadharNumber === null) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter Aadhar Number', field: 'aadharNumber' + i })
        //         break
        //     } else if ((data[i].aadharNumber).length !== 12) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter valid Aadhar Number', field: 'aadharNumber' + i })
        //         break
        //     } else if ((data[i].aadharNumber) === '000000000000') {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter valid Aadhar Number', field: 'aadharNumber' + i })
        //         break
        //     }

        // }
        return formStatus
    }

    const saveHandler = (e) => {

        if (e === 'save') {
            if (validationHandler(objectData)) {
                setLoaderState(true)
                objectData.forEach((element, i) => {
                    // if(element.panNumber )
                    // console.log(i)
                    // console.log(objectData.length - 1)
                    if (element.name) {
                        CommunityLeadSaveUserDirectorApi(element, Callback => {

                            if (i === (objectData.length - 1)) {
                                if (data.rowData.loanId !== undefined) {
                                    Callback.data.loanId = data.rowData.loanId
                                }
                                Callback.data.sourceOfIncome = data.rowData.sourceOfIncome
                                if (!window.location.href.includes("/external")) {
                                    const obj = { rowData: Callback.data,
                                         communityId: data ? data.communityId : null,
                                          qrId : data ? data.qrId : null 
                                        }
                                        handleTab("addLeadAddress",obj)
                                    // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_ADDRESS : Routes.COMMUNITY_ADD_LEAD_ADDRESS, { state: { rowData: Callback.data, communityId: location.state ? location.state.communityId : null, qrId : location.state ? location.state.qrId : null } })
                                }
                                setLoaderState(false)
                            }
                        }, error => {
                            // console.log(error)
                        })
                    } else {
                        if (!window.location.href.includes("/external")) {

                            const  obj ={
                                rowData: data.rowData,
                                 communityId: data ? data.communityId : null,
                                  qrId : data ? data.qrId : null
                            }
                            // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_ADDRESS : Routes.COMMUNITY_ADD_LEAD_ADDRESS, { state: { rowData: location.state.rowData, communityId: location.state ? location.state.communityId : null, qrId : location.state ? location.state.qrId : null } })
                            handleTab("addLeadAddress",obj)
                        }
                       
                    }
                })
            }
        } else if (e === 'close') {
            // if (location.state ? location.state.communityId : null) {
            //     let data = location.state.rowData
            //     data.communityId = location.state ? location.state.communityId : null
            //     navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: data, page: 'communityLeads' } })
            // } else if (location.state ? location.state.qrId : null) {
            //     let data = location.state.rowData
            //     data.qrId = location.state ? location.state.qrId : null
            //     navigate(Routes.SUPER_ADMIN_QR_DETAILS, { state: { rowData: data, page: 'leads' } })
            // } else
            //     navigate(window.location.href.includes('admin') ? Routes.SUPER_ADMIN_ALL_LEADS : Routes.COMMUNITY_ALL_LEADS)
            handlePage("","list")
        } else if (e === 'back') {
            // if (!window.location.href.includes('/external')) {
            //     navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_BUSINESS :
            //         Routes.COMMUNITY_ADD_LEAD_BUSINESS, { state: { rowData: objectData[0], communityId: location.state ? location.state.communityId : null  } })
            // } else {
            //     navigate(Routes.EXTERNAL_COMMUNITY_ADD_LEAD_BUSINESS, { state: { rowData: objectData[0] } })
            // }

            const obj ={ rowData: objectData[0], communityId: data ? data.communityId : null  }

            handleTab("adminAddLeadBusiness",obj)
        }
    }

    // console.log(objectData)

    return (
        <div className='container hoverNone card'>
            {loaderState ?
                <Loader />
                : null}
            <div style={{ fontSize: '13px', marginLeft: '11px', marginTop: '10px' }} >Add Director Details</div >
            {deletePopupState ?
                <DeletePopup
                    deleteHandler={deleteHandler}
                />
                : null}
            {/* {console.log((objectData), 'objectData')} */}
            {
                objectData.map((data, i) => {
                    return (
                        <div key={i} className="card" style={{ marginTop: '15px' }}>
                            <div style={{ marginLeft: '10px', fontSize: '14px' }}><b>Director Detail {i + 1}</b></div>
                            <div className='card-header'>
                                <div className='btn-group'>
                                    <button
                                        className='cred-btn center-block mr-3'
                                        onClick={e => mainActionHandler('mainAdd', i)}
                                    ><i className='fa fa-plus' /></button>
                                    <button
                                        className='cred-btn center-block'
                                        onClick={e => mainActionHandler('mainRemove', i)}
                                    ><i className='fa fa-minus' /></button>
                                </div>
                            </div>
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-xs-12 ' style={{marginBottom:'12px'}}>
                                        <InputField
                                            label="Name"
                                            variant="outlined"
                                            value={data.name}
                                            name="name"
                                            id="name"
                                            type="text"
                                            onChange={e => inputChange(e, 'name', i)}
                                            size="small"
                                        />
                                        <div id="nameHelp" className="form-text text-danger">{validationMsg.field === 'name' + i ? validationMsg.msg : ""}</div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                                        <InputField
                                            label="PAN No"
                                            variant="outlined"
                                            value={data.panNumber}
                                            name="panNumber"
                                            id="panNumber"
                                            type="text"
                                            onChange={e => inputChange(e, 'panNumber', i)}
                                            size="small"
                                        />
                                        <div id="panNumberHelp" className="form-text text-danger">{validationMsg.field === 'panNumber' + i ? validationMsg.msg : ""}</div>
                                    </div>
                                    <div className='col-sm-6 col-xs-12 'style={{marginBottom:'12px'}}>
                                        <InputField
                                            label="Aadhaar No."
                                            variant="outlined"
                                            value={data.aadharNumber}
                                            name="aadharNumber"
                                            id="aadharNumber"
                                            type="number"
                                            onChange={e => inputChange(e, 'aadharNumber', i)}
                                            size="small"
                                        />
                                        <div id="aadharNumberHelp" className="form-text text-danger">{validationMsg.field === 'aadharNumber' + i ? validationMsg.msg : ""}</div>
                                    </div>
                                    <div className='col-sm-6 col-xs-12'style={{marginBottom:'12px'}}>
                                        <InputField
                                            label="Name as on PAN"
                                            variant="outlined"
                                            value={data.nameOnPan}
                                            name="nameOnPan"
                                            id="nameOnPan"
                                            type="text"
                                            onChange={e => inputChange(e, 'nameOnPan', i)}
                                            size="small"
                                            readOnly={true}
                                        />
                                        <div id="nameOnPanHelp" className="form-text text-danger">{validationMsg.field === 'nameOnPan' + i ? validationMsg.msg : ""}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            <div className='mt-3 row 'style={{marginBottom:'12px'}}>
                <div className="col-12 text-center">
                    {
                        !window.location.href.includes('/external') ?
                            <button className="cred-btn cancel-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('close')}>Close</button>
                            :
                            <a href={WEBSITE}> <button type="button" style={{fontSize:'16px'}} className="cred-btn">Close</button></a>
                    }
                    <button className="cred-btn cancel-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('back')}>Back</button>
                    <button className="cred-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('save')}>Save and Continue</button>
                </div>
            </div>
        </div>
    )
}

export default EsignConfig;